import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import './tripTags.css';

const TripTags = ({ tripDetailsData }) => {
    return (
        <>
            <TripDetailsSubHeading text={'Tags'} />
            {tripDetailsData?.tags?.length > 0 &&
                tripDetailsData?.tags?.map((tagItem, index) => {
                    return (
                        <div key={index} className='tagsDetailsDiv'>
                            <span className='tagsDetailsSpan'>➡️ {tagItem}</span>
                        </div>
                    );
                })}
        </>
    );
};

export default TripTags;
